/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { Logo } from "frontend/src/components/Logo"
import { FaMapMarker } from "react-icons/fa"
import PropTypes from "prop-types"

const Wrapper = ({ logo, place, handleClick }) => {
  const cursor = handleClick ? "pointer" : "default"
  return (
    <div
      role="button"
      tabIndex="0"
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        userSelect: "none",
        transform: "translate(-50%,-50%)",
        cursor: cursor,
        "&:hover": { zIndex: 1 },
      }}
      onClick={() => handleClick(place)}
      onKeyDown={ev => {
        if (ev.keyCode === 13) {
          handleClick(place)
        }
      }}
    >
      <Logo name={logo} height="1.5em" />
    </div>
  )
}

const WrapperSelected = ({ logo, place }) => (
  <div
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      userSelect: "none",
      backgroundColor: "gold_100",
      opacity: 0.6,
      transform: "translate(-50%,-50%)",
    }}
  >
    <Logo name={logo} height="1.5em" />
  </div>
)

const CenterWrapper = ({ onClick }) => {
  const cursor = onClick ? "pointer" : "default"
  return (
    <div
      sx={{
        position: "absolute",
        top: "calc(50% - 1.25em)",
        left: "50%",
        userSelect: "none",
        transform: "translate(-50%,-50%)",
        cursor: cursor,
      }}
    >
      <FaMapMarker style={{ color: "almostBlack", fontSize: "2.5em", opacity: 0.8 }} />
    </div>
  )
}

const Marker = props => {
  const { logo, place, handleClick, selectedStore } = props
  if (selectedStore) {
    const isSelected =
      place.storeCoordinates.latitude === selectedStore.storeCoordinates.latitude &&
      place.storeCoordinates.longitude === selectedStore.storeCoordinates.longitude
    if (isSelected) {
      return <WrapperSelected logo={logo} alt={props.text} place={place} />
    }
  }
  return <Wrapper logo={logo} alt={props.text} handleClick={handleClick} place={place} />
}
Marker.defaultProps = {
  onClick: null,
}

Marker.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
}

const CenterMarker = props => (
  <CenterWrapper alt={props.text} {...(props.onClick ? { onClick: props.onClick } : {})} />
)

export { Marker, CenterMarker }
